import React from 'react';
import { Button } from '@/components/ui/Button';
import { useCounterOfferSubmission } from '@/hooks/useCounterOfferSubmission';
import { useCounterOfferStore } from '@/stores/counterOfferStore';
import { TextArea } from '../../ui/TextArea';

type CounterOfferNoteStepProps = {
  poolId: number;
};

export const CounterOfferNoteStep: React.FC<CounterOfferNoteStepProps> = ({ poolId }) => {
  const previousStep = useCounterOfferStore((state) => state.previousStep);
  const isFirstStep = useCounterOfferStore((state) => state.isFirstStep);
  const note = useCounterOfferStore((state) => state.note);
  const setNote = useCounterOfferStore((state) => state.setNote);

  const { submitCounterOffer, isSubmitting } = useCounterOfferSubmission({
    poolId,
  });

  const handleSubmit = async () => {
    try {
      await submitCounterOffer();
    } catch {
      // Validation errors and navigation are handled inside submitCounterOffer
    }
  };

  return (
    <div className="p-8 flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <label className="text-sm text-gray-600">Add a note (optional)</label>
        <TextArea value={note} onChange={setNote} placeholder="Enter your note here..." rows={6} />
      </div>

      {/* Action Buttons */}
      <div className="flex gap-4 justify-end pt-4 border-t border-gray-200">
        {!isFirstStep() && (
          <Button onClick={previousStep} variant="secondary" disabled={isSubmitting}>
            Previous
          </Button>
        )}
        <Button onClick={handleSubmit} disabled={isSubmitting} loading={isSubmitting}>
          Send the counter offer
        </Button>
      </div>
    </div>
  );
};
